// type text = {
//   text: string
// }

export const text = {
  about: `פרופ' ליאור גרינבאום, MD PhD, הוא רופא מומחה לנוירולוגיה ולגנטיקה רפואית, ומנהל שירות נוירוגנטיקה במכון הגנטי במרכז הרפואי שיבא.  הוא פרופ' חבר בחוג לנוירולוגיה באוניברסיטת תל אביב.
פרופ' גרינבאום עוסק באבחון גנטי למצבים נוירולוגיים והתפתחותיים שונים בילדים, נוער ומבוגרים. לאורך השנים צבר נסיון קליני רב בתחום. בין השאר הוא מתמחה באבחון גנטי למחלות עצב שריר, אפילפסיה, הפרעות תנועה, דמנציה, אוטיזם, לקות קוגניטיבית, שבץ מוחי בגיל צעיר, מחלות  נוירו-מטאבוליות ותסמונות רקמת חיבור.
מטרות האבחון הגנטי בכלל, והנוירוגנטי בפרט, הינן איתור הבסיס המולקולרי הגורם לתסמינים הרלוונטים של המטופל, הערכת סיכון ההישנות בצאצאים של הנועץ וקרובי משפחתו, והצעת דרכים לצמצום סיכון זה.
ההתפתחות הטכנולוגית הניכרת בתחום בשנים האחרונות מאפשרת כיום בירור מהיר וזול יחסית, ולעיתים אף להרחיב את אפשרויות המעקב והטיפול.
   `,
  aboutBottom: `פרופ' ליאור גרינבאום סיים את לימודיו בביה"ס לרפואה של האוניברסיטה העברית והדסה בשנת 2006. במהלך הלימודים השלים תואר שני (MSc) בחוג לנוירוביולוגיה, ובהמשך גם תואר שלישי (PhD) בחוג זה באוניברסיטה העברית, בתחום הפרמקוגנטיקה של מחלת הסכיזופרניה.
בהמשך,  פרופ' גרינבאום השלים בשנת 2015 התמחות בנוירולוגיה (מבוגרים) והתמחות נוספת בגנטיקה רפואית (2018), שניהם במרכז הרפואי שיבא.
במסגרת המכון הגנטי בשיבא, הוא הקים את המרפאה הנוירוגנטית ומשנת 2022 מכהן כמנהל שירות ניורוגנטיקה בבית החולים.
פרופ' גרינבאום עוסק רבות במחקר בתחום הגנטיקה של מחלות נוירולוגיות ופסיכיאטריות, השתתף כמחבר בכתיבת מעל 75 מאמרים מדעיים ובעל מינוי של פרופ' חבר בחוג לנוירולוגיה באוניברסיטת תל אביב.

-	לרשימת הפרסומים המדעיים `,
  neuroConsultationIntro: `תחום הנוירוגנטיקה עוסק באבחון גנטי למגוון רחב של מחלות ומצבים רפואיים המערבים את המח ומערכת העצבים הפריפרית, תוך שימוש בכלי אבחון מתקדמים. 
  בעשור האחרון חלה התקדמות עצומה בתחום הגטיקה הקלינית, בעיקר בעקבות השלמת פרוייקט ריצוף הגנום האנושי ופיתוח טכנולוגיות ריצוף גנומי זמינות וזולות. הדבר הוביל לפריצות דרך רבות, ובמצבים רפואיים רבים שנחשבו בעבר הלא רחוק כ"לא גנטיים" ניתן כיום לזהות שינויים גורמי מחלה בחלק מאוכלוסיית החולים.`,
  neuroConsultation1: `בייעוץ אנו עוברים על הרקע ההתפתחותי והרפואי של הנבדק, משרטטים אילן משפחה ומתייחסים למצבים רלוונטיים במשפחה.
<strong>בשלב הראשון</strong> נאספים נתונים על תוצאות הבירור והאבחון הרפואי שבוצע עד כה, כולל בדיקות עזר שונות (MRI מח וחוט שדרה, EEG, בדיקות מוליכות עצבית ועוד). לפיכך, חשוב מאוד להגיע עם כל המסמכים הרפואיים הרלוונטיים, כולל דיסקים של בדיקות ההדמייה (אם יש). לאחר ביצוע בדיקה גופנית ונוירולוגית מקיפה, אנו מנסים להעריך את ההסתברות לקיום בעיה גנטית (בד"כ הכוונה למצב חד-גני בעקבות שינויים בגן אחד או באזור גנומי ספציפי) בנבדק ובמשפחתו, ולהציע דרכים רלוונטיות ומעשיות לאבחון, כמו למשל בדיקת ריצוף אקסום. 
<strong>בשלב הבא בתהליך</strong>, ולאחר השלמת הבדיקות המומלצות, אנו עוברים על תוצאותיהן, וקובעים האם נמצאה אבחנה גנטית. לעיתים מציאת האבחנה הגנטית מאפשרת לחסוך שנים רבות של בדיקות רפואיות אחרות, חלקן פולשניות (כגון ביופסייה ועוד), ומאפשרת לחסוך זמן, משאבים ואמצעים כספיים רבים. 
מציאת האבחנה הגנטית מאפשרת להעריך ביתר דיוק את סיכון ההישנות למצב דומה בנבדק ובבני משפחתו המתכננים ילודה, כולל אפשרויות לאבחון טרום לידתי ואף אבחון טרום השרשתי (PGD). 
בנוסף, בעידן של רפואה מתואמת אישית, תוצאות הבירור הגנטי יכולות להוביל בחלק מהמקרים להנחיות ספציפיות ומדוייקות יותר לגבי משטר המעקב והטיפול , ואף להכווין להשתתפות במחקרים קליניים המיודעים לפיתוח טיפולים תרופתיים שונים.`,
  neuroConsultation2: `בייעוץ הנוירוגנטי, הנבדק ו/או בני משפחתו מקבלים הסבר מפורט על הסיכוי כי אכן מדובר במצב גנטי, ועל האפשרויות לברר זאת. הדבר נעשה תוך התחשבות ברצונות ובמניעים הספציפיים בכל מקרה, ובאורחות חייהם של הנועצים ובני משפחתם. לעיתים מדובר בסיטואציות משפחתיות רגישות, בעיקר כאשר הריון של קרוב משפחה מדרגה ראשונה נמצא על הפרק, וקיים חשש להישנות מצב דומה בצאצאים. הבירור הגנטי יכול לעורר תחושות אי נוחות, חשש מתיוג (סטיגמה) ואף חרדה. אני מנסה לשקלל גורמים אלה בתמונה הכללית, ובמידת האפשר להפיג את החששות ולהרגיע.  
בזכות ההתפתחות הטכנולוגית המהירה, תחום הגנטיקה הרפואית מתפתח ומשתנה במהירות. פענוח רצף הגנום האנושי בתחילת שנות האלפיים והתפתחות נוספות שקרו בהמשך פתחו צוהר לאמצעי אבחון ומניעה שלא היו בנמצא עד לפני שנים אחדות. עם זאת, יש לזכור כי לצד יתרונות משמעותיים, לבדיקות הגנטיות גם חסרונות, כמו האפשרות לקבלת ממצאים שמשמעותם אינה ברורה או ממצאים אקראיים,  שלא היו המטרה המקורית של ביצוע הבדיקה. יש להבין זאת ולקחת בחשבון את העובדה שהתוצאות המתקבלות אינן תמיד בבחינת "שחור או לבן".   
לכל אדם האוטונומיה לבחור את אפשרות הבירור המתאימה לו (כולל האפשרות לוותר על ביצוע  בירור גנטי).  מבחינתי, חשוב להעביר לנועצים את מלוא המידע לגבי מצבם, הבירור וההשלכות האפשריות – כדי שיוכלו לקבל בעצמם החלטה מושכלת לגבי צעדיהם העתידיים.
 
לבסוף, צריך לזכור כי תוצאות הבדיקות הגנטיות ופירושן מתאימות תמיד למועד בו בוצעו ובו ניתן הייעוץ הגנטי. כדאי להסתכל על הבירור הנוירוגנטי כתהליך שלעיתים הוא קצר וממוקד, ולעיתים ארוך ולא תמיד מאפשר, לצערנו, להגיע לתוצאות חד משמעיות. לכן, בחלק מהמקרים מסוג זה מומלץ לבצע רביזיה של תוצאות הבדיקות, ולחזור שוב לייעוץ גנטי בעוד מספר שנים, בתקווה שהידע המדעי והרפואי יתרחבו בעתיד.`,
  expertiseTitle: `המחלות והמצבים הרפואיים בהם אני עוסק במבוגרים, נוער וילדים (מעל גיל 4 שנים):`,
};

export const expertise = {
  title: "המחלות והמצבים הרפואיים בהם אני עוסק במבוגרים, נוער וילדים (מעל גיל 4 שנים):",
  list: [
    {
      subtitle: "מחלות עצב שריר",
      types: [
        "נוריופטיות, דוגמת CMT  ",
        "מחלות שריר (מיופטיות)",
        "מחלות נוירון מוטורי (ALS)",
        "חוסר סבילות למאמצים גופניים ורבדומיוליזיס",
      ],
    },
    {
      subtitle: "אפילפסיה",
      types: [],
    },
    {
      subtitle: "הפרעות תנועה",
      types: [
        "פרקינסון ותסמונות דומות, בדגש על גיל הופעה צעיר",
        "דיסטוניה",
        "אטקסיה",
        "Hereditary spastic paresis",
        "תסמונת טורט",
      ],
    },
    {
      subtitle: "לקות קוגניטיבית",
      types: [],
    },
    {
      subtitle: "עיכוב התפתחותי",
      types: [],
    },
    {
      subtitle: "ספקטרום האוטיזם",
      types: [],
    },
    {
      subtitle: "שבץ מוחי בגיל צעיר",
      types: [],
    },
    {
      subtitle: "קברנומות מוחיות",
      types: [],
    },
    {
      subtitle: "שיתוק מוחין (CP)",
      types: [],
    },
    {
      subtitle: "ירידה קוגניטיבית ודמנציה בגיל צעיר, כולל Frontotemporal dementia",
      types: [],
    },
    {
      subtitle: "מחלות נוירו-מטאובליות ומיטוכונדריאליות",
      types: [],
    },
    {
      subtitle: "מחלות חומר לבן מוחי (כולל לויקודיסטרופיות)",
      types: [],
    },
    {
      subtitle: "הפרעות מבניות מוחית מולדות (כגון פולימיקרוגיריה, הטרוטופיה, הידרוצפלוס ועוד)",
      types: [],
    },
    {
      subtitle: "תסמונות רקמת חיבור (כולל אהלר דנלוס)",
      types: [],
    },
  ],
};

export const tests = {
  title: "הבדיקות הנפוצות במסגרת בירור נוירוגנטי:",
  intro: `באופן כללי, הבדיקות מבוצעות על דנ"א המופק מהדם. זמן קבלת התשובה הינו בד"כ בין חודש לחודשיים (תלוי במעבדה).
בדיקת האקסום מבוצעת במימון פרטי הרוב המקרים, ואילו שאר הבדיקות במימון ציבורי (בהתאם לאינדיקציה הרפואית).

הבדיקות הנפוצות בהן נעשה שימוש כוללות:

`,
  list: [
    {
      subtitle: "בדיקת ריצוף כלל אקסומי (whole exome sequencing)",
      content: `ריצוף (או קריאה) של כלל הגנים המקודדים לחלבון. באדם כ-20,000 גנים המקודדים לחלבון (לערך), ואלו מהווים רק כ-1% מכלל רצף הגנום האנושי (כלומר, כ-30 מליון בסיסים מתוך 3 מליארד). ידוע כי הרוב הגדול (85%-90%) מכלל המחלות החד-גניות באדם נגרם בשל שינויים הנמצאים באותו חלק קטן של הגנום המקודד לחלבון (exome). 
מטרת בדיקת הריצוף היא איתור מוטציות נקודתיות ("שגיאות כתיב"  ברצף הגנטי) הגורמות בסבירות רבה למחלה.
פענוח ריצוף האקסום דורש מיומנות גבוה של המעבדה המבצעת, המסתייעת בשיטות ביואינפורמטיות מורכבות. זאת כדי להבדיל בין שינויים גנטיים שפירים (benign) לשינויים בעלי משמעות קלינית. לכל אדם שינויים רבים בגנום, חלקן יחודיים ונדירים, אך רק למיעוטם משמעות קלינית העשויה להשפיע על בריאות הנבדק.  בחלק מהמקרים ישנה חשיבות לשילוב גם בני משפחה נוספים במסגרת בדיקת האקסום, לצורך השוואה בין בריאים לחולים. 
מאחר ומדובר בבדיקה רחבה, תתכן גם קבלת ממצאים שמשמעותם הקלינית אינה ברורה (variant of uncertain significant) שיצריכו המשך בירור, או ממצאים אקראיים שלא היו מטרת ביצוע הבדיקה מלכתחילה. 

    `,
    },
    {
      subtitle: "בדיקת שבב גנטי (chromosomal microarray – CMA)",
      content: `בדיקת השבב הגנטי (או צ'יפ גנטי) מאפשרת גילוי חסרים ותוספות כרומוסומליים זעירים. הכוונה בעצם לחסר (deletion) או הכפלה (duplication) של מקטעים גנומיים שונים, העשויים להכיל בין גן אחד (או חלק ממנו) ועד עשרות גנים. שינויים אלה נקראים copy number variants (CNVs). בדיקת השבב מבוצעת היום כחלק רוטיני באבחון טרום לידתי בבדיקת סיסי שפיר וסיסי שלייה. הרזולוציה של בדיקת השבב הגנטי גבוה משמעותית מזו של בדיקת הקריוטיפ המסורתית, ובד"כ מהווה תחליף לה.
לחלק מה-CNVs שמתגלים בבדיקת השבב הגנטי משמעות פתוגנית ברורה וחד משמעית, ואילו חלקם מהווים גורמי סיכון למצבים שונים (כגון לקות קוגניטיבית, אוטיזם ועוד), בשל חדירות חלקית וביטוי משתנה.

    `,
    },
    {
      subtitle: "בדיקת ריצוף פאנל גנטי ",
      content: `לעיתים ניתן להסתפק בריצוף מספר מוגבל של מקבץ גנים רלוונטיים לקליניקה (עשרות עד מאות בודדות). זאת, בעיקר במקרים בהם התמונה הקלינית ברורה ומוגדרת (למשל, נוירופטיה או מיופטיה). בחלק מהפאנלים, בשל ההתמקדות במקבץ קטן יחסית של גנים, איכותו הטכנית של  הריצוף גבוהה יותר מאשר באקסום, והסיכוי להחמיץ קיום ממצאים בעלי משמעות בגנים אלה מופחת. שימוש בפאנל גם מצמצם את הסיכוי לקבלת ממצאים שמשמעותם הקלינית אינה ברורה. מאידך, כאשר הקליניקה אינה מוגדרת היטב או לחילופין רחבה ומערבת מספר מערכות גופניות, רוב הגנטיקאים יעדיפו ריצוף אקסום. 
   `,
    },
    {
      subtitle: "בדיקת רצפי הרחבה ",
      content: `חלק מהמחלות הנוירולוגיות נגרמות של הרחבה של רצפים חוזרים. הכוונה לאזורים המכילים חזרות של 3-6 בסיסים (אותיות). במחלות מסויימות מספרן של החזרות גדל משמעותיות, ועם חציית סף מסויים הוא גוארם להופעת מחלה. הכוונה למחלות כמו למשל X שביר, מיוטוניק דיסטרופי 1 או 2, מחלת הנטיגנטון ועוד. איתור שינויים אלה מחייב בדיקה ייעודית, המבוצעת במעבדות שונות בארץ.
נדגיש כי בדיקות אלה אינן מייתרות האחת את השנייה, אלא לרוב משלימות זו את זו. כך למשל בבדיקת השבב הגנטי אינה תחליף לריצוף, ולהיפך. פעמים רבות מבצעים יותר מסוג בדיקה אחת.  
לבסוף, לאחר קבלת התוצאות, יש לבצע אינטגרציה של המידע הקליני, הבדיקה הנוירולוגית, בדיקות העזר ותוצאות הבדיקות הגנטיות. זאת כדי להבין מה הקשר בין התוצאות שנמצאו בבירור הגנטי (גנוטיפ) לבין מצבו של הנועץ (פנוטיפ). לעיתים הדבר פשוט, ולעיתים מורכב ולא חד משמעי. לנסיון ולידע של הרופא משקל קריטי בסיכום הממצאים, וקביעת האבחנה הגנטית הנכונה.  

   `,
    },
  ],
};
